export const employmentStatusOptions = ["Regular", "Contractual", "Probationary"];
